/**
 * "Email me when back in stock" signup (snippets/back-in-stock.liquid).
 *
 * Listens to the theme's bubbling "variant:changed" event to show the signup only for sold out variants, and keeps
 * the hidden customer form's tags/note in sync with the selected variant.
 */
(function () {
  'use strict';

  if (window.__backInStockInitialized) {
    return;
  }

  window.__backInStockInitialized = true;

  var MAX_TAG_LENGTH = 255;

  function sanitize(value) {
    return String(value || '').replace(/,/g, '').trim();
  }

  function getItemTitle(container, variant) {
    var title = sanitize(container.getAttribute('data-product-title'));

    if (container.getAttribute('data-has-only-default-variant') !== 'true' && variant && variant.title) {
      title += ' - ' + sanitize(variant.title);
    }

    return title;
  }

  function updateHiddenForm(container, variant) {
    var form = document.getElementById(container.getAttribute('data-form-id'));

    if (!form || !variant) {
      return;
    }

    var itemTitle = getItemTitle(container, variant);
    var tag = ('Back in stock: ' + itemTitle).slice(0, MAX_TAG_LENGTH);
    var tagsInput = form.querySelector('input[name="contact[tags]"]');
    var noteInput = form.querySelector('input[name="contact[note]"]');

    if (tagsInput) {
      tagsInput.value = 'newsletter, back-in-stock, ' + tag;
    }

    if (noteInput) {
      noteInput.value = 'Back in stock request: ' + itemTitle + ' (variant ' + variant.id + ') ' + container.getAttribute('data-product-url');
    }

    container.setAttribute('data-variant-id', variant.id);
    container.setAttribute('data-item-title', itemTitle);
  }

  function resetState(container) {
    Array.prototype.forEach.call(container.querySelectorAll('[data-back-in-stock-alert]'), function (alert) {
      alert.style.display = 'none';
    });

    var fields = container.querySelector('[data-back-in-stock-fields]');

    if (fields) {
      fields.style.display = '';
    }
  }

  document.addEventListener('variant:changed', function (event) {
    var section = event.target.closest('.shopify-section') || event.target.closest('[data-section-id]');
    var container = section && section.querySelector('[data-back-in-stock]');

    if (!container) {
      return;
    }

    var variant = event.detail ? event.detail.variant : null;

    resetState(container);

    if (variant && !variant.available) {
      updateHiddenForm(container, variant);
      container.style.display = '';
    } else {
      container.style.display = 'none';
    }
  });

  // After a submission Shopify redirects back with "?customer_posted=true#<form id>" but drops "?variant=", so the page
  // falls back to the first available variant. Reload once with the variant the customer signed up for.
  var STORAGE_PREFIX = 'backInStockVariant:';

  function hasCaptcha() {
    return !!(window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function');
  }

  function getSignupForm(element) {
    var form = element && element.form;

    return form && document.querySelector('[data-back-in-stock][data-form-id="' + form.id + '"]') ? form : null;
  }

  // Shopify binds its hCaptcha when focus enters a form, but the signup inputs live outside the (hidden) customer form
  // and only point at it through the "form" attribute, so bind it ourselves to have it ready by the time they submit.
  document.addEventListener('focusin', function (event) {
    var form = getSignupForm(event.target);

    if (form && hasCaptcha() && !form.hasAttribute('data-hcaptcha-bound')) {
      window.Shopify.captcha.protect(form);
    }
  });

  function getContainer(form) {
    return form && form.id ? document.querySelector('[data-back-in-stock][data-form-id="' + form.id + '"]') : null;
  }

  function saveVariant(form, container) {
    try {
      window.sessionStorage.setItem(STORAGE_PREFIX + form.id, container.getAttribute('data-variant-id'));
    } catch (error) {
      // Storage may be unavailable (e.g. private mode); the signup still works
    }
  }

  function removeCaptchaToken(form) {
    Array.prototype.slice.call(form.elements).forEach(function (input) {
      if (input.name === 'h-captcha-response' && input.parentNode) {
        input.parentNode.removeChild(input);
      }
    });
  }

  // Submits the customer form as a regular page submission, which Shopify answers with "?customer_posted=true#<form id>"
  // (or its own captcha page when it wants one). The captcha needs a fresh token for every submission.
  function submitSignup(form) {
    removeCaptchaToken(form);

    if (hasCaptcha()) {
      window.Shopify.captcha.protect(form, function () {
        form.submit();
      });
    } else {
      form.submit();
    }
  }

  // Captures the submit before Shopify's captcha handlers so every attempt gets a fresh token. The store is emailed by a
  // Shopify Flow workflow (Customer tags added → "Back in stock:" tag → Send internal email to info@enjoypearl.com).
  window.addEventListener('submit', function (event) {
    var form = event.target;
    var container = getContainer(form);

    if (!container) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    if (container.classList.contains('is-loading')) {
      return;
    }

    container.classList.add('is-loading');

    // Lets the shopper retry if a captcha challenge is dismissed
    window.setTimeout(function () {
      container.classList.remove('is-loading');
    }, 20000);

    saveVariant(form, container);
    submitSignup(form);
  }, true);

  function restoreVariantAfterPost(container) {
    var formId = container.getAttribute('data-form-id');
    var params = new URLSearchParams(window.location.search);
    var storedVariantId = null;

    if (window.location.hash !== '#' + formId) {
      return false;
    }

    try {
      storedVariantId = window.sessionStorage.getItem(STORAGE_PREFIX + formId);
      window.sessionStorage.removeItem(STORAGE_PREFIX + formId);
    } catch (error) {
      return false;
    }

    if (params.get('customer_posted') !== 'true' || params.has('variant') || !storedVariantId || storedVariantId === container.getAttribute('data-variant-id')) {
      return false;
    }

    params.set('variant', storedVariantId);
    window.location.replace(window.location.pathname + '?' + params.toString() + window.location.hash);

    return true;
  }

  // Shopify shares form.posted_successfully? and form.errors between every customer form on the page (e.g. the footer
  // newsletter), so only keep the server-rendered success/error when this signup was the one submitted.
  function scopeServerState() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-back-in-stock]'), function (container) {
      if (!container.querySelector('[data-back-in-stock-alert]') || window.location.hash === '#' + container.getAttribute('data-form-id')) {
        return;
      }

      resetState(container);

      if (container.getAttribute('data-variant-available') === 'true') {
        container.style.display = 'none';
      }
    });
  }

  // That form is hidden, so scroll to the visible signup instead.
  function onLoad() {
    scopeServerState();

    if (!window.location.hash) {
      return;
    }

    var container = document.querySelector('[data-back-in-stock][data-form-id="' + window.location.hash.slice(1).replace(/"/g, '') + '"]');

    if (!container || restoreVariantAfterPost(container)) {
      return;
    }

    if (container.style.display !== 'none') {
      container.scrollIntoView({ block: 'center' });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onLoad);
  } else {
    onLoad();
  }
})();
